import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Breadcrumb, Button, PageHeader, Table, Tag, Tooltip } from "antd";
import Page from "_components/Page";
import { DownloadOutlined } from "@ant-design/icons";
import Search from "./Search";
import { ApplicationDocumentService } from "_services/applicationdocument.service";
import moment from "moment";

function List({ history, match }) {
  const { path } = match;
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [items, setItems] = useState([]);

  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchParams, setSearchParams] = useState("");
  const [downloading, setDownloading] = useState(false);

  const getDocuments = (pageNumber, pageSize) => {
    let paginationParams = searchParams.indexOf("?") === -1 ? "?" : "&";
    paginationParams += `pageNumber=${pageNumber}&pageSize=${pageSize}`;

    setIsLoading(true);

    ApplicationDocumentService.getSuggestion(`${searchParams}`)
      // .search(`${searchParams}${paginationParams}`)
      .then((data) => {
        setItems(data.content || []);
        // setTotalRecords(data.pagination.totalRecords);
        // setPageNumber(data.pagination.pageNumber);
        setIsLoading(false);
      })
      .catch((error) => {
        setError(error);
        setIsLoading(false);
      });
  };

  //use the stock classification id to get finished products
  useEffect(() => {
    // if (stockClassificationTypeId) {
    getDocuments(pageNumber, pageSize);
    //getDocuments();
    //}
  }, []);
  const handleDownloadFile = (documentObj) => {
    setDownloading(true);
    ApplicationDocumentService.downloadDocument(documentObj.id)
      .then((response) => {
        const url = window.webkitURL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${documentObj.documentName}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setDownloading(false);
      })
      .catch((error) => {
        setDownloading(false);
        setError(error);
      });
  };

  const columns = [
    {
      title: "Application Date",
      dataIndex: "applicationDate",
      key: "applicationDate",
      render: (text, record) =>
        text ? (
          <Link to={`${path}/${record.id}/summary`}>
            {moment(text).format("YYYY-MM-DD")}
          </Link>
        ) : (
          "-"
        ),
    },
    /* {
      title: "Application Document Type",
      dataIndex: "applicationDocumentType",
      key: "applicationDocumentType",
      render: (text) => text || "-",
    }, */
    {
      title: "Company",
      dataIndex: ["company", "name"],
      key: "company",
      render: (text, record) => (
        <Link to={`${path}/${record.id}/summary`}>
          {record.company?.name || "-"}
        </Link>
      ),
    },
    {
      title: "VAT Number",
      dataIndex: ["company", "vatNo"],
      key: "companyCode",
      render: (text) => <Tag color="#13c2c2">{text}</Tag> || "-",
    },
    {
      title: "Authorised By",
      dataIndex: "authorisedBy",
      key: "authorisedBy",
      render: (text, record) =>
        record.authorisedBy
          ? `${record.authorisedBy.firstName} ${record.authorisedBy.lastName}`
          : "-",
    },
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
      render: (text) => text || "-",
    },
    {
      title: "Status",
      dataIndex: "applicationStatus",
      key: "applicationStatus",
      render: (applicationStatus) => {
        let color = "";
        if (applicationStatus === "APPROVED") {
          color = "green";
        } else if (applicationStatus === "PENDING") {
          color = "orange";
        } else if (applicationStatus === "REJECTED") {
          color = "red";
        } else if (applicationStatus === "APPLICATION") {
          color = "#fa8c16";
        }
        return <Tag color={color}>{applicationStatus}</Tag>;
      },
    },
    {
      title: "",
      key: "downloadFile",
      render: (text, record) => (
        {/* <Button
          icon={<DownloadOutlined />}
          title="Download Document"
          type="link"
          style={{ marginRight: 10 }}
          loading={downloading}
          onClick={() => handleDownloadFile(record)}
        ></Button> */}
      ),
    },
  ];
  const handlePaginateChange = (pageNumber, pageSize) => {
    getDocuments(pageNumber, pageSize);
  };

  const handleSearchResults = (results, totalRecords, searchParams) => {
    setItems(results);
    // setTotalRecords(totalRecords);
    setSearchParams(searchParams);
    setPageNumber(1);
    setIsLoading(false);
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/documents">Registration</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/documents">TIEP Applications</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={[
          <Link to={`${path}/upload`} key="btn-bom-upload">
            <Button>Apply</Button>
          </Link>,
        ]}
      >
        <Page inner error={error}>
          <Search
            showSearchLoading={setIsLoading}
            onSearchResults={handleSearchResults}
          />
          <Table
            bordered
            rowKey="id"
            columns={columns}
            dataSource={items}
            size="small"
            loading={isLoading}
            pagination={{
              current: pageNumber,
              pageSize: pageSize,
              total: totalRecords,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              onChange: handlePaginateChange,
            }}
          />
        </Page>
      </PageHeader>
    </div>
  );
}

export default List;
